namespace Matrix.Data {
    export class PartyRelationshipColumns {
        static columnsKey = 'Matrix.Data.Columns.PartyRelationshipColumns';
    }
}
